import * as marietta from '../..';
import * as network from '../../pixelstreaming/network/player';
import * as pscommand from '../../pixelstreaming/commands'

import { ThreeView } from "./index";

class PSSceneManagement implements network.playerStatus {
    constructor() {
    }

    public onChange(status) {
        if (status === network.statustype.connect) {
            console.log('Connect - PSS DataChannel');

            this.createScene();
            ThreeView.get().isPSVideoMode = true;
            ThreeView.get().ItemDragManager.enabled = false;
        }
        if (status == network.statustype.disconnect) {
            ThreeView.get().isPSVideoMode = false;
            ThreeView.get().ItemDragManager.enabled = true;
        }
    }

    // シーンの初期化
    public resetScene() {
        return new Promise((resolve) => {
            const reset = new pscommand.develop('reset');
            ThreeView.get().pscommunication.send(reset.object());
            resolve(resolve);
        });
    }
    // - create scene ------
    // GLB, Extras送信
    // カメラデータ送信
    public createScene() {

        const GLBData = ThreeView.get().wcItemmgr.BinaryData;
        const extras = ThreeView.get().wcItemmgr.GltfExtras;

        const sendglb = () => {
            return new Promise((resolve) => {
                const glb = new pscommand.GLB(GLBData);

                const datas = glb.object();

                datas.forEach((data) => {
                    console.log(`send GLB ${data}`);
                    ThreeView.get().pscommunication.send(data);
                });
                resolve(resolve);
            });
        }

        const sendExtras = () => {
            return new Promise((resolve) => {
                const ext = new pscommand.divideSceeneEtras(extras);

                const datas = ext.object();

                datas.forEach((data) => {
                    // console.log(`send extras - ${JSON.stringify(data)}`);
                    ThreeView.get().pscommunication.send(data);
                });
                resolve(resolve);
            });
        }

        const setlocale = () => {
            return new Promise((resolve) => {
                const daytime = new pscommand.placeDateStatus();
                daytime.setDate(ThreeView.get().dayTime);
                daytime.setPlace(ThreeView.get().placeData.longitude, ThreeView.get().placeData.latitude, ThreeView.get().placeData.timezone);
                ThreeView.get().pscommunication.send(daytime.object());
                resolve(resolve);
            });
        }

        const setLight = () => {
            return new Promise((resolve) => {
                const light = new pscommand.lightSetting();
                light.setLight(ThreeView.get().lightSetting.intensity, ThreeView.get().lightSetting.temperature);
                ThreeView.get().pscommunication.send(light.object());
                resolve(resolve);
            });
        }

        this.resetScene().then(() => {
            setlocale().then(() => {
                sendglb().then(() => {
                    // ThreeView.get().pscommunication.send(new pscommand.sceneextras(extras).object());
                    sendExtras().then(() => {
                        // console.log('divscene');
                        setLight().then(() => {
                            ThreeView.get().pscamerasetup();
                        })
                    })
                // }).then(() => {
                //     ThreeView.get().pscamerasetup();
                // }).then(() => {

                    // const unfreezCommand = new pscommand.develop('unfreeze');
                    // ThreeView.get().pscommunication.send(unfreezCommand.object());
                });
            });
        });
    }

    public sendCamera() {
        if (ThreeView.get().isPSVideoMode != true) return;
        const camera = <THREE.PerspectiveCamera>(ThreeView.get().cameras.camera.me);
        const stateObject = new pscommand.cameraStatus(camera, ThreeView.get().wcCameras.isWalkThroughCameraMode());
        ThreeView.get().pscommunication.send(stateObject.object());
    }

    public getImage() {
        if (ThreeView.get().isPSVideoMode != true) return;

        const imageRequest = () => {
            return new Promise((resolve) => {
                const highres = new pscommand.highres(3840, 2160);

                ThreeView.get().pscommunication.send(highres.object());
                resolve(resolve);
            });
        }

        imageRequest().then(() => {
            marietta.webcad.WebCADGlobal.showBusy("レンダリング画像リクエスト中...");
        });
    }
}

export default PSSceneManagement;
